import React, { lazy } from 'react';
import { Route, Routes } from 'react-router-dom';

import { PATH_DASHBOARD } from 'routers/paths';
import { RoleRouter } from 'routers/RoleRouter';
import { ROLES } from 'config';

const UserReferralReports = lazy(() => import('pages/reports/UserReferralReports'));
const UserAccessReports = lazy(() => import('pages/reports/UserAccessReports'));
const ChallengesReports = lazy(() => import('pages/reports/ChallengesReports'));
const UserSubscriptions = lazy(() => import('pages/reports/UserSubscriptions'));
const UserOakleySubscriptions = lazy(() => import('pages/reports/UserOakleySubscriptions'));

const ClassCreditsReports = lazy(() => import('pages/reports/ClassCreditsReports'));
const GymAttendanceReportsWithRedLine = lazy(() => import('pages/reports/GymAttendanceReportsWithRedLine'));
const GymAttendanceReports = lazy(() => import('pages/reports/GymAttendanceReports'));
const InfluencersReports = lazy(() => import('pages/reports/InfluencersReports'));
const StudioAttendancePerClassReportFacilityAdmin = lazy(() =>
  import('pages/reports/StudioAttendancePerClassReportsFacilityAdmin')
);
const UsersAccessReportsGymFacilityAdmin = lazy(() => import('pages/reports/UsersAccessReportsGymFacilityAdmin'));
const UsersAttendanceGymFacilityAdmin = lazy(() => import('pages/reports/UsersAttendanceReportsGymFacilityAdmin'));
const UsersAttendanceReportStudioFacilityAdmin = lazy(() =>
  import('pages/reports/UsersAttendanceReportsStudioFacilityAdmin')
);
const ItemizedSalesReport = lazy(() => import('pages/reports/ItemizedSalesReport'));
const RetailSalesReport = lazy(() => import('pages/reports/RetailSalesReport'));
const VendorSalesReport = lazy(() => import('pages/reports/VendorSalesReport'));
const PersonalTrainersCommissionReport = lazy(() => import('pages/reports/PersonalTrainersCommissionReport'));
const Dubai3030Report = lazy(() => import('pages/reports/Dubai3030Report'));
const ChallengeActivityReport = lazy(() => import('pages/reports/ChallengesActivityReport'));
const PersonalTrainersSalesReport = lazy(() => import('pages/reports/PersonalTrainersSalesReport'));

const NotFound = lazy(() => import('pages/Page404'));

export default function Reports() {
  return (
    <Routes>
      <Route
        path={`${PATH_DASHBOARD.dubai3030Report.root}/*`}
        element={
          <RoleRouter permittedRole={[ROLES.YFC_ADMIN, ROLES.SUPER_ADMIN]}>
            <Dubai3030Report />
          </RoleRouter>
        }
      />
      <Route
        path={`${PATH_DASHBOARD.challengesActivityReport.root}/*`}
        element={
          <RoleRouter permittedRole={[ROLES.YFC_ADMIN, ROLES.SUPER_ADMIN, ROLES.CHALLENGE_ADMIN]}>
            <ChallengeActivityReport />
          </RoleRouter>
        }
      />
      <Route
        path={`${PATH_DASHBOARD.userReferralReport.root}/*`}
        element={
          <RoleRouter permittedRole={[ROLES.YFC_ADMIN, ROLES.FRANCHISE_REGION_ADMIN, ROLES.SUPER_ADMIN]}>
            <UserReferralReports />
          </RoleRouter>
        }
      />
      <Route
        path={`${PATH_DASHBOARD.userAccessReport.root}/*`}
        element={
          <RoleRouter permittedRole={[ROLES.YFC_ADMIN, ROLES.FRANCHISE_REGION_ADMIN, ROLES.SUPER_ADMIN]}>
            <UserAccessReports />
          </RoleRouter>
        }
      />
      <Route
        path={`${PATH_DASHBOARD.challengesReport.root}/*`}
        element={
          <RoleRouter permittedRole={[ROLES.YFC_ADMIN, ROLES.FRANCHISE_REGION_ADMIN, ROLES.SUPER_ADMIN]}>
            <ChallengesReports />
          </RoleRouter>
        }
      />
      <Route
        path={`${PATH_DASHBOARD.userSubscriptions.root}/*`}
        element={
          <RoleRouter permittedRole={[ROLES.YFC_ADMIN, ROLES.FRANCHISE_REGION_ADMIN, ROLES.SUPER_ADMIN]}>
            <UserSubscriptions />
          </RoleRouter>
        }
      />
      <Route
        path={`${PATH_DASHBOARD.userOakleySubscriptions.root}/*`}
        element={
          <RoleRouter permittedRole={[ROLES.YFC_ADMIN, ROLES.FRANCHISE_REGION_ADMIN, ROLES.SUPER_ADMIN]}>
            <UserOakleySubscriptions />
          </RoleRouter>
        }
      />

      <Route
        path={`${PATH_DASHBOARD.personalTrainersCommissionReport.root}/*`}
        element={
          <RoleRouter permittedRole={[ROLES.YFC_ADMIN, ROLES.FRANCHISE_REGION_ADMIN, ROLES.SUPER_ADMIN]}>
            <PersonalTrainersCommissionReport />
          </RoleRouter>
        }
      />
      <Route
        path={`${PATH_DASHBOARD.personalTrainersSalesReport.root}/*`}
        element={
          <RoleRouter permittedRole={[ROLES.YFC_ADMIN, ROLES.FRANCHISE_REGION_ADMIN, ROLES.SUPER_ADMIN]}>
            <PersonalTrainersSalesReport />
          </RoleRouter>
        }
      />
      <Route
        path={`${PATH_DASHBOARD.classCreditsReport.root}/*`}
        element={
          <RoleRouter permittedRole={[ROLES.YFC_ADMIN, ROLES.FRANCHISE_REGION_ADMIN, ROLES.SUPER_ADMIN]}>
            <ClassCreditsReports />
          </RoleRouter>
        }
      />
      <Route
        path={`${PATH_DASHBOARD.gymAttendanceWithRedLine.root}/*`}
        element={
          <RoleRouter permittedRole={[ROLES.YFC_ADMIN, ROLES.FRANCHISE_REGION_ADMIN, ROLES.SUPER_ADMIN]}>
            <GymAttendanceReportsWithRedLine />
          </RoleRouter>
        }
      />
      <Route
        path={`${PATH_DASHBOARD.gymAttendanceReports.root}/*`}
        element={
          <RoleRouter permittedRole={[ROLES.YFC_ADMIN, ROLES.FRANCHISE_REGION_ADMIN, ROLES.SUPER_ADMIN]}>
            <GymAttendanceReports />
          </RoleRouter>
        }
      />
      <Route
        path={`${PATH_DASHBOARD.influencersReports.root}/*`}
        element={
          <RoleRouter permittedRole={[ROLES.YFC_ADMIN, ROLES.FRANCHISE_REGION_ADMIN, ROLES.SUPER_ADMIN]}>
            <InfluencersReports />
          </RoleRouter>
        }
      />
      <Route
        path={`${PATH_DASHBOARD.itemizedSalesReport.root}/*`}
        element={
          <RoleRouter permittedRole={[ROLES.YFC_ADMIN, ROLES.FRANCHISE_REGION_ADMIN, ROLES.SUPER_ADMIN]}>
            <ItemizedSalesReport />
          </RoleRouter>
        }
      />
      <Route
        path={`${PATH_DASHBOARD.retailSalesReport.root}/*`}
        element={
          <RoleRouter permittedRole={[ROLES.YFC_ADMIN, ROLES.FRANCHISE_REGION_ADMIN, ROLES.SUPER_ADMIN]}>
            <RetailSalesReport />
          </RoleRouter>
        }
      />
      <Route
        path={`${PATH_DASHBOARD.vendorSalesReport.root}/*`}
        element={
          <RoleRouter
            permittedRole={[ROLES.YFC_ADMIN, ROLES.VENDOR_ADMIN, ROLES.FRANCHISE_REGION_ADMIN, ROLES.SUPER_ADMIN]}
          >
            <VendorSalesReport />
          </RoleRouter>
        }
      />
      <Route
        path={`${PATH_DASHBOARD.studioAttendancePerClassReport.root}/*`}
        element={
          <RoleRouter permittedRole={[ROLES.FACILITY_ADMIN]}>
            <StudioAttendancePerClassReportFacilityAdmin />
          </RoleRouter>
        }
      />
      <Route
        path={`${PATH_DASHBOARD.userAccessReportGymFacilityAdmin.root}/*`}
        element={
          <RoleRouter permittedRole={[ROLES.FACILITY_ADMIN]}>
            <UsersAccessReportsGymFacilityAdmin />
          </RoleRouter>
        }
      />
      <Route
        path={`${PATH_DASHBOARD.usersAttendanceGymReportFacilityAdmin.root}/*`}
        element={
          <RoleRouter permittedRole={[ROLES.FACILITY_ADMIN]}>
            <UsersAttendanceGymFacilityAdmin />
          </RoleRouter>
        }
      />
      <Route
        path={`${PATH_DASHBOARD.usersAttendanceReportStudioFacilityAdmin.root}/*`}
        element={
          <RoleRouter permittedRole={[ROLES.FACILITY_ADMIN]}>
            <UsersAttendanceReportStudioFacilityAdmin />
          </RoleRouter>
        }
      />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
